import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { VisitService } from "src/app/dp-services/visit.service";
import { ItalianDateParserFormatter } from "../visit.component";

@Component({
  selector: "app-voucher-visit",
  templateUrl: "./voucher-visit.component.html",
  styleUrls: ["./voucher-visit.component.scss"],
  providers: [
    { provide: NgbDateParserFormatter, useClass: ItalianDateParserFormatter },
  ],
})
export class VoucherVisitComponent implements OnInit {
  visitID: any;
  errore = true;
  carricamentoDati = false;

  completeVisitForm: FormGroup = this.formBuilder.group({
    ID: [null],
    FirstName: [null],
    LastName: [null],
    Phone: [null],
    Email: [null],
    Nperson: [null],
    Nchild: [null],
    NchildUnder6: [null],
    VisitDate: [null, Validators.required],
    VisitTime: [null, Validators.required],
    VisitDateInit: [null],
    VisitTimeInit: [null],
    VisitTimeID: [null],
    Language: [null],
    Tasting: [null],
    Tasting2: [null],
    Tasting3: [null],
    Total: [null],
    Canceled: [null],
    Refund: [null],
    Regalo: [null],
    EmailDestinatarioRegalo: [null],
    Payments: [null],
  });

  submitted = false;

  timeOptions: { id: string; ora: string }[] = [
    {
      id: "",
      ora: "Prima selezionare la data.",
    },
  ];
  orarioVisita: any;
  tomorrow: any;

  minDate: NgbDateStruct;
  dateModel: NgbDateStruct;
  availableDates: Set<string> = new Set();
  isDateDisabled = (date: NgbDateStruct): boolean => {
    return !this.availableDates.has(this.ngbDateToString(date));
  };

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private visitService: VisitService,
  ) {}

  ngOnInit(): void {
    var date = new Date();
    this.tomorrow = date.setDate(date.getDate() + 1);

    const tomorrowDate = new Date(this.tomorrow);
    this.minDate = {
      year: tomorrowDate.getFullYear(),
      month: tomorrowDate.getMonth() + 1,
      day: tomorrowDate.getDate(),
    };

    var visitid = this.route.snapshot.params.visit_id;
    if (visitid !== undefined) {
      this.visitService
        .getReservationByID(visitid)
        .toPromise()
        .then(
          (res) => {
            if (res) {
              this.visitID = visitid;
              this.completeVisitForm.patchValue(res);
              this.completeVisitForm.patchValue({
                VisitDateInit: res.VisitDate,
                VisitTimeInit: res.VisitTime,
              });
              this.errore = false;
              this.carricamentoDati = true;
              this.loadAvailableDates();
            }
          },
          (error) => {
            this.errore = true;
          },
        );
    }
  }

  get form() {
    return this.completeVisitForm.controls;
  }

  private ngbDateToString(date: NgbDateStruct): string {
    const mm = String(date.month).padStart(2, "0");
    const dd = String(date.day).padStart(2, "0");
    return `${date.year}-${mm}-${dd}`;
  }

  private formatDateForApi(date: Date): string {
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${date.getFullYear()}-${mm}-${dd}`;
  }

  loadAvailableDates() {
    const Language = this.completeVisitForm.get("Language")?.value;
    const start = this.formatDateForApi(new Date(this.tomorrow));
    const endDate = new Date(this.tomorrow);
    endDate.setMonth(endDate.getMonth() + 6);
    const end = this.formatDateForApi(endDate);

    this.visitService
      .getVisitDatesAvailable(Language, start, end)
      .subscribe((dates) => {
        this.availableDates = new Set(dates);
      });
  }

  onDateSelect(date: NgbDateStruct) {
    this.dateModel = date;
    this.completeVisitForm.get("VisitDate")?.setValue(this.ngbDateToString(date));
    this.changeVisitDate();
  }

  async changeVisitDate() {
    const Nperson = this.completeVisitForm.get("Nperson")?.value;
    const Nchild = this.completeVisitForm.get("Nchild")?.value;
    const VisitDate = this.completeVisitForm.get("VisitDate")?.value;
    const VisitLang = this.completeVisitForm.get("Language")?.value;
    const tot = Number(Nperson) + Number(Nchild);

    if (tot && tot !== 0) {
      const response = await this.visitService
        .setVisitTimes(VisitDate, VisitLang, tot)
        .toPromise();

      if (response && response.length > 0) {
        this.timeOptions = response;
        this.completeVisitForm.get("VisitTime").setValue(response[0].ora); // Imposta il primo orario disponibile
        this.completeVisitForm.get("VisitTimeID").setValue(response[0].id);
      } else {
        this.timeOptions = [
          {
            id: "",
            ora: "Non ci sono orari disponibili, si consiglia di scegliere un altro giorno.",
          },
        ];
        this.completeVisitForm.get("VisitTime").setValue("");
        this.completeVisitForm.get("VisitTimeID").setValue("");
      }
    } else {
      this.timeOptions = [
        {
          id: "",
          ora: "Prima selezionare la data.",
        },
      ];
      this.completeVisitForm.get("VisitTime").setValue("");
      this.completeVisitForm.get("VisitTimeID").setValue("");
    }
  }

  selectVisitTime(item: { id: string; ora: string }) {
    this.completeVisitForm.get("VisitTime")?.setValue(item.ora);
    this.completeVisitForm.get("VisitTimeID")?.setValue(item.id);
  }

  get hasTimeOptions(): boolean {
    return this.timeOptions.some((item) => item.id !== "");
  }

  salvaVisita() {
    if (this.completeVisitForm.valid) {
      this.completeVisitForm.patchValue({
        VisitTimeID: 1
      });

      this.visitService
        .updateVisit(this.completeVisitForm.getRawValue())
        .subscribe({
          next: (res) => { 
             window.location.reload();
          },
        });
    }
    this.submitted = true;
  }
}
